import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './wwex-sub-view-header.messages';

type WwexSubViewHeaderProps = {
  titleMessage: MessageDescriptor;
  isDisabled?: boolean;
  onBack: () => void;
};

export const WwexSubViewHeader = ({ titleMessage, isDisabled = false, onBack }: WwexSubViewHeaderProps) => {
  const intl = useIntl();

  return (
    <FlexRow gap={Gap.Space12}>
      <Button
        ariaLabel={intl.formatMessage(messages.backButtonLabel)}
        disabled={isDisabled}
        onClick={onBack}
        theme={THEME_CONSTANTS.unstyled}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </Button>
      <Text textType={TextType.H3} value={titleMessage} />
    </FlexRow>
  );
};
